export default __webpack_public_path__ + "static/media/home-trend-up.2ccb5975.svg";